import type {NavigationGuard} from 'vue-router';
import {get} from '@vueuse/core';
import useAcl from '@/composables/useAcl/useAcl';

export const subscriptionFeatureGuard: NavigationGuard = (to) => {
  const {hasSubscriptionFeature} = useAcl();

  if (!to?.meta?.subscriptionFeatures) {
    return true;
  }

  const hasAccessToSubscriptionFeatures = to.meta.subscriptionFeatures.every((feature) =>
    get(hasSubscriptionFeature(feature)),
  );

  if (hasAccessToSubscriptionFeatures) {
    return true;
  }

  if (to.meta.redirectTo) {
    return to.meta.redirectTo;
  }

  return {name: 'dashboard'};
};
